export default "__VITE_ASSET__camTS_y9__"